import { Link } from "@tanstack/react-router";
import { Menu, X, ClipboardList } from "lucide-react";
import { useState } from "react";
import { useInquiry } from "@/lib/inquiry-store";
import logo480 from "@/assets/logo-mark-480.webp";
import logo960 from "@/assets/logo-mark-960.webp";
const links = [
  { to: "/koncept", label: "Våra koncept" },
  { to: "/foretag", label: "Företagsevent" },
  { to: "/massa", label: "Mässor" },
  { to: "/om-oss", label: "Om oss" },
  { to: "/kontakt", label: "Kontakt" },
];
export function Header() {
  const [open, setOpen] = useState(false);
  const { count } = useInquiry();
  return (
    <header className="experience-nav">
      <div className="experience-wrap nav-row">
        <Link
          to="/"
          className="brand-link"
          aria-label="Event Sverige startsida"
          onClick={() => setOpen(false)}
        >
          <img
            src={logo480}
            srcSet={`${logo480} 480w, ${logo960} 960w`}
            sizes="(max-width: 720px) 176px, 236px"
            width="921"
            height="168"
            alt="Event Sverige"
            className="brand-logo"
            decoding="async"
          />
        </Link>
        <nav aria-label="Huvudnavigation" className="desktop-nav">
          {links.map((l) => (
            <Link key={l.to} to={l.to} activeProps={{ className: "active" }}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="nav-tools">
          <Link to="/forfragan" className="nav-inquiry">
            <ClipboardList size={17} />
            <span>Min förfrågan</span>
            {count > 0 && <b>{count}</b>}
          </Link>
          <button
            className="mobile-menu"
            aria-label={open ? "Stäng meny" : "Öppna meny"}
            aria-expanded={open}
            aria-controls="mobile-navigation"
            onClick={() => setOpen(!open)}
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <nav id="mobile-navigation" className="mobile-nav" aria-label="Mobilnavigation">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}>
              {l.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
